/**
 * Orden alfabético por razón social, insensible a mayúsculas y acentos.
 * `localeCompare` con 'es' evita que "Ñandú" caiga después de "Z" o que
 * "ecoEnergía" se separe de "EcoEnergia".
 */
const compararPorRazonSocial = (a, b) =>
  String(a?.razonSocial ?? '').localeCompare(String(b?.razonSocial ?? ''), 'es', { sensitivity: 'base' })

const normalizarContrato = (contrato) => {
  if (contrato == null || contrato === '') return null

  const numero = Number(contrato)
  return Number.isFinite(numero) ? numero : null
}

/**
 * Ordena las cuentas A→Z por razón social (criterio 5) y antepone la cuenta
 * con la que el usuario está logueado (criterio 6).
 *
 * Se aplica antes de paginar para que la cuenta activa quede primera de la
 * página 1, no primera de su página.
 *
 * @param {Array<{razonSocial?: string, contrato?: number|string}>} cuentas
 * @param {number|string|null} contratoActivo
 * @returns {Array} nuevo array, sin mutar el original
 */
export function ordenarCuentas(cuentas, contratoActivo) {
  if (!Array.isArray(cuentas)) return []

  const ordenadas = [...cuentas].sort(compararPorRazonSocial)
  const activo = normalizarContrato(contratoActivo)

  if (activo === null) return ordenadas

  const indice = ordenadas.findIndex((cuenta) => normalizarContrato(cuenta?.contrato) === activo)

  // -1: la cuenta activa no está en la lista. 0: ya quedó primera por orden alfabético.
  if (indice <= 0) return ordenadas

  const [cuentaActiva] = ordenadas.splice(indice, 1)
  return [cuentaActiva, ...ordenadas]
}
